<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span><router-link to="/contacts/list_contacts" class="text-white pl-2 text-line">Contacts</router-link></span>
                    <a>{{this.$route.params.id == 'new' ? 'Create' : 'Edit'}} Contact</a>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center" v-if="ajaxCallInProgress">
                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
            </div>
            <div v-else-if="!ajaxCallInProgress">
                <div  class="main-div">
                    <div class="col-lg-6 col-md-6 col-sm-12 ml-2 px-5 pt-2">
                        <div class="d-flex align-items-center my-3" :class="{'pointer-event':this.$route.params.id != 'new'}">
                            <div class="d-flex justify-content-between align-items-center" >
                                <span class="text-secondary fs-14 fw-600 mr-2">Business Contact</span>
                                <div class="form-check form-check-inline mr-7 mb-1 ">
                                    <label class="form-check-label check-label-dc">
                                        <input class="form-check-input" :disabled="business_true" type="radio" value="business" name="Business" @change="changeAccount(selected_account)" v-model="selected_account"/>
                                        <span class="radio-icon"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="text-secondary fs-14 fw-600 mr-2">Personal Contact</span>
                                <div class="form-check form-check-inline mr-7 mb-1  ">
                                    <label class="form-check-label check-label-dc">
                                        <input class="form-check-input"  :disabled="personal_true" type="radio" value="personal" name="personal" @change="changeAccount(selected_account)" v-model="selected_account"/>
                                        <span class="radio-icon"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-outer mt-3">
                        <span class="fw-500">Basic Information</span>
                        <span class="pointer" @click="showBasicInformation">
                            <i v-if="basicInformationTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                            <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                        </span>
                    </div>
                    <div class="inner-div" v-if="basicInformationTab">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-6 mt-3 pl-0">
                                <div class="d-flex justify-content-start tab-paddding">
                                    <div class="mr-8">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="text-secondary fs-14 fw-600 ml-5 mr-3" style="width:70px !important">Profile</div>
                                            <div class="form-check form-check-inline mr-7" style="width: 40px !important">
                                                <label class="form-check-label check-label-dc radio-margin">
                                                    <input class="form-check-input" type="radio" value="profile_pic" v-model="pic_type"/>
                                                    <span class="radio-icon"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="pointer" @click="editPicture" style="position: relative;" :disabled="avatar_pic">
                                            <img class="mt-3 img-width" style="margin-left: 16px;width: 100px !important;" :src="profile_pic">
                                            <img src="/static/images/images-new-theme/icons/editgreynew.svg" height="25" style="position: absolute;bottom: 0 !important;">
                                        </div>
                                    </div>
                                    <div class="ml-2">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <span class="text-secondary fs-14 fw-600 mr-3" style="width:74px !important">Avatar</span>
                                            <div class="form-check form-check-inline mr-7" style="width:40px !important">
                                                <label class="form-check-label check-label-dc avatar-radio-margin">
                                                    <input class="form-check-input" type="radio" value="avatar" v-model="pic_type" />
                                                    <span class="radio-icon"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="pointer mt-3" @click="editAvatar" style="position: relative;">
                                            <img class="img-width" :src="avatar_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Avatar 1.svg'" style="width: 100px !important;">
                                            <img src="/static/images/images-new-theme/icons/editgreynew.svg" height="25" style="position: absolute;bottom: 0 !important;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-12 col-sm-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-4">
                                        <div>
                                            <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                Title <sup class="fs-14 text-danger">*</sup>
                                            </span>
                                            <div class="d-flex align-items-center">
                                                <div class="w-100" v-if="!reset_title">
                                                    <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3" ref="new_title_multiselectInput" v-validate="'required'" name="new_title_multiselect" @search-change="searchTitle" :searchable="true" :options="title_options" v-model="title" placeholder="Select Title">
                                                        <template slot="afterList">
                                                            <div class="add-vendor fw-500" v-if="add_title" @click="addTitle()">
                                                                Add New Title <span class="text-secondary fw-500"></span>
                                                                <i class="icon icon-plus ml-2 mt-1 float-right text-secondary"></i>
                                                            </div>
                                                        </template>
                                                        <template slot="noOptions">
                                                            <div class="text-secondary text-center fw-600">List is Empty</div>
                                                        </template>
                                                        <template slot="noResult">
                                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                    </multiselect>
                                                </div>
                                                <div class="mt-4" v-else-if="reset_title" style="width: 100%;">
                                                    <input @input="titleInput()" class="inputFieldNew input-height mt-1" type="text" maxlength="60" v-model="new_title" name="new_title_multiselect" placeholder="Enter New Title"/>
                                                    <span class="highlightContact"></span>
                                                    <span class="barContact"></span>
                                                </div>
                                                <!--span class="pointer" @click="changeView()">
                                                    <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-3" style="width:20px" alt="">
                                                    </el-tooltip>
                                                </span-->
                                            </div>
                                             <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('new_title_multiselect')">Title is Required</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                                        <div class="d-flex align-items-center">
                                            <div class="form-group w-100">
                                                <input class="inputFieldNew" ref="first_nameInput" v-validate="'required'" type="text" name="first_name" maxlength="45" v-model="first_name" placeholder="Enter First Name" />
                                                <span class="inputBorder"></span>
                                                <label class="inputLabel fs-14 fw-600">First Name
                                                    <sup class="fs-14 text-danger">*</sup>
                                                </label>
                                            </div>
                                        </div>
                                        <span class="input-field-length float-right">{{ first_name.length }}/45</span>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('first_name')">First Name is Required</span>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                                        <div class="d-flex align-items-center">
                                            <div class="form-group w-100">
                                                <input class="inputFieldNew input-height" type="text" v-model="middle_name" maxlength="45" placeholder="Enter Middle Name" />
                                                <span class="inputBorder"></span>
                                                <label class="inputLabel fs-14 fw-600">
                                                    Middle Name
                                                </label>
                                            </div>
                                            <!-- <i class="icon icon-check-circle fs-30 mt-9 ml-2" style="color: #ff9a06;"></i> -->
                                        </div>
                                        <span class="input-field-length float-right">{{ middle_name.length }}/45</span>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 mt-3">
                                        <div class="d-flex align-items-center">
                                            <div class="form-group w-100">
                                                <input class="inputFieldNew input-height" ref="lastnameInput" v-validate="'required'" maxlength="45" type="text" name="lastname" v-model="last_name" placeholder="Enter Last Name" />
                                                <span class="inputBorder"></span>
                                                <label class="inputLabel fs-14 fw-600">Last Name
                                                    <sup class="fs-14 text-danger">*</sup>
                                                </label>
                                            </div>
                                            <!-- <i class="icon icon-check-circle fs-30 mt-9 ml-2" style="color: #ff9a06;"></i> -->
                                        </div>
                                        <span class="input-field-length float-right">{{ last_name.length }}/45</span>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('lastname')">Last Name is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="selected_account == 'business'">
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-5" v-if="$route.params.id == 'new' || ($route.params.id != 'new' && stored_company_name_for_edit == '')">
                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Company Name <sup class="fs-14 text-danger">*</sup></span>
                                <div class="d-flex align-items-center" >
                                    <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3" @open="searchCompanyName"
                                    track-by="id"
                                    ref="company_name_multiselectInput"
                                    v-validate="'required'"
                                    :loading="company_loading"
                                    :limit="1"
                                    :limit-text="limitCompanyName"
                                    :blockKeys="['Delete']"
                                    @remove="removeCompanyName"
                                    :multiple="false"
                                    :allow-empty="true"
                                    :searchable="true"
                                    :taggable="true"
                                    :clear-on-select="false"
                                    :close-on-select="true"
                                    :preserve-search="true"
                                    tag-placeholder="Add this as new company"
                                    label="customer_name"
                                    @tag="addTag"
                                    name="company_name_multiselect"
                                    @search-change="searchCompanyName"
                                    :options="company_name_options"
                                    v-model="company_name"
                                    placeholder="Select Company Name"
                                    :preselect-first="false">
                                    <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Company Names not found
                                            </div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-left fw-600" @click="addCompanyName()">+Add Company Name</div>
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfCompanies" />
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="invalid-feedback-form text-danger pl-0" style="text-transform: none !important;" v-show="errors.has('company_name_multiselect')">Company Name is Required</div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-4" v-else>
                                <div class="d-flex align-items-center" >
                                    <div class="form-group w-100 tab-paddding">
                                        <input class="inputFieldNew input-height" disabled type="text" name="company_name_multiselect" v-model="company_name" placeholder="Enter Company Name" />
                                        <span class="inputBorder"></span>
                                        <label class="inputLabel fs-14 fw-600">Company Name<sup class="fs-14 ml-02 text-danger">*</sup></label>
                                    </div>
                                </div>
                                <span class="input-field-length float-right">{{ company_name.length }}/50</span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-4">
                                <div class="d-flex align-items-center">
                                    <div class="form-group w-100">
                                        <input class="inputFieldNew input-height" type="text" name="jobtitle" maxlength="50" v-model="job_title" placeholder="Enter Job Title" />
                                        <span class="inputBorder"></span>
                                        <label class="inputLabel fs-14 fw-600"> Job Title</label>
                                        <span class="input-field-length float-right fs-14">{{ job_title.length }}/50</span>
                                    </div>

                                </div>

                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                                <div>
                                    <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Industry Type
                                        <sup class="fs-14 text-danger">*</sup>
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <div class="w-100  mt-3">
                                            <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow" ref="industry_type_multiselectInput" v-validate="'required'" :searchable="true" :options="industry_type_options" name="industry_type_multiselect" v-model="industry_type" placeholder="Select Industry">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">
                                                        Industry Types not found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No
                                                        Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('industry_type_multiselect')">Industry Type is Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-if="selected_account == 'business'">
                                <div class="d-flex align-items-center">
                                    <div class="w-100 mt-2">
                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Territory</span>
                                        <multiselect label="name" @search-change="searchTerritory" @open="fetchTerritory" track-by="id" :loading="territory_loading" :limit="1"  :limit-text="limitTerritory" v-model="territory" :blockKeys="['Delete']" @remove="removeTerritory" placeholder="Select Territory" class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2" id="ajaxgb" :options="territory_options" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" >
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center font-weight-bold" >Territories Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfTerritories" />
                                            </template>
                                        </multiselect>
                                    </div>
                                    <span class="pointer mt-5" @click="changeTerritoryView()">
                                        <el-tooltip class="item" effect="dark" content="The value is auto-filled and configurable in Settings. Click here to go to Settings" placement="bottom">
                                            <img src="/static/images/images-new-theme/icons/settings-new-right.svg" class="ml-2 mt-3" style="width:20px" alt="">
                                        </el-tooltip>
                                    </span>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-5" v-if="selected_account == 'personal'">
                                <div>
                                    <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">Relation
                                        <sup class="fs-14 text-danger">*</sup>
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <div class="w-100 mt-2">
                                            <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow" ref="relation_multiselectInput" v-validate="'required'" :searchable="true" :options="relation_options" name="relation_multiselect" v-model="relation" placeholder="Select Relation">
                                                <template slot="noOptions">
                                                    <div class="text-secondary text-center fw-600">
                                                        Relations not found</div>
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No
                                                        Results Found
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('relation_multiselect')">Relation is Required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-6 col-sm-12 mt-3">
                                <div class="d-flex align-items-center">
                                    <div class="form-group w-100">
                                        <input class="inputFieldNew input-height" type="text" maxlength="100" name="notes" v-model="notes" placeholder="Enter Notes" />
                                        <span class="inputBorder"></span>
                                        <label class="inputLabel fs-14 fw-600"> Notes</label>
                                        <span class="input-field-length float-right fs-14">{{ notes.length }}/100</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-outer mt-3">
                        <span class="fw-500">Contact</span>
                        <span class="pointer" @click="showContact">
                            <i v-if="contactTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                            <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                        </span>
                    </div>
                    <div class="inner-div" v-if="contactTab">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div class="d-flex align-items-center">
                                    <div class="form-group w-100">
                                        <input class="inputFieldNew input-height email-text-valid" type="text" maxlength="100" ref="primary_emailInput" name="primary_email" v-model="primary_email" @input="checkEmailExist($event)" v-validate="'required|email'" placeholder="Enter Primary Email" />
                                        <span class="inputBorder"></span>
                                        <label class="inputLabel fs-14 fw-600">Primary Email
                                            <sup class="fs-14 text-danger">*</sup>
                                        </label>
                                        <span class="input-field-length float-right fs-14">{{ primary_email.length }}/100</span>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('primary_email')">Please Enter a Valid Email</span>
                                    </div>
                                </div>

                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-4">
                                <div>
                                    <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                        Mobile Number <sup class="fs-14 ml-02 text-danger">*</sup>
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <div v-if="$route.params.id != 'new'" class="w-100">
                                            <vue-tel-input v-bind="bindProps" :defaultCountry="contact_details.contact_phone_number.length > 0 ? contact_details.contact_phone_number[0].country_code : 'US'"
                                            @onInput="contactPhoneInput" class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-3"
                                            name="mobile_number" v-model="contact_mobile_number.phone_number"
                                            v-validate="{required:true,min:10}" :valid-characters-only="true"
                                            :maxLen="15" placeholder="Enter Mobile Number"
                                            :disabledFormatting="false" style="width:100% !important; margin-right: 30px;"></vue-tel-input>
                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('mobile_number')">{{errors.first('mobile_number')}}</span>
                                        </div>
                                        <div v-else class="w-100">
                                            <vue-tel-input v-bind="bindProps"
                                            @onInput="contactPhoneInput" class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-3"
                                            name="mobile_number" v-model="contact_mobile_number.phone_number"
                                            v-validate="{required:true,min:10}" :valid-characters-only="true"
                                            :maxLen="15" placeholder="Enter Mobile Number"
                                            :disabledFormatting="false" style="width:100% !important; margin-right: 30px;"></vue-tel-input>
                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('mobile_number')">{{errors.first('mobile_number')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div>
                                    <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                        Business Phone
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <div v-if="$route.params.id != 'new'" class="w-100">
                                            <vue-tel-input v-bind="bindProps"  @onInput="businessPhoneInput" class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-4" name="business_phone" v-model="business_mobile_number.phone_number" v-validate="{min:10}" :valid-characters-only="true" :maxLen="15" placeholder="Enter Business Phone" :disabledFormatting="false"  style="width:100% !important; margin-right: 30px;"></vue-tel-input>
                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('business_phone')">{{errors.first('business_phone')}}</span>
                                        </div>
                                        <div v-else class="w-100">
                                            <vue-tel-input v-bind="bindProps" @onInput="businessPhoneInput" class="number-field-width-customer teleContactborderedDark new-align-tel ml-0 mt-4" name="business_phone" v-model="business_mobile_number.phone_number" v-validate="{min:10}" :valid-characters-only="true" :maxLen="15" placeholder="Enter Business Phone" :disabledFormatting="false"  style="width:100% !important; margin-right: 30px;"></vue-tel-input>
                                            <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('business_phone')">{{errors.first('business_phone')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                                <div class="d-flex align-items-center">
                                    <div class="form-group w-100 ">
                                        <input class="inputFieldNew input-height email-text-valid" type="text" maxlength="100" name="alternate_email" v-model="alternate_email" v-validate="'email'" placeholder="Enter Alternate Email" />
                                        <span class="inputBorder"></span>
                                        <label class="inputLabel fs-14 fw-600">Alternate Email
                                            <!-- <sup class="fs-14 ml-02 ">*</sup> -->
                                        </label>
                                        <span class="input-field-length float-right fs-14">{{ alternate_email.length }}/100</span>
                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('alternate_email')">Please Enter a Valid Email</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" >
                            <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-for="(address, index) in address" :key="index">
                                <div class="remainder-list">
                                    <div class="d-flex justify-content-between align-items-baseline">
                                        <!-- <div class="text-justify text-flow word-break-all"></div> -->
                                        <div class="text-justify text-flow word-break-all">
                                            <span>{{address.building_number||''}}</span>
                                            <span v-if="address.building_number">,</span>
                                            <span>{{address.street||''}}</span>
                                            <span v-if="address.street">,</span>
                                            <span>{{address.township||''}}</span>
                                            <span v-if="address.township">,</span>
                                            <span>{{address.city}}</span>
                                            <span v-if="address.city">,</span>
                                            <span>{{address.state||''}}</span>
                                            <span v-if="address.state">,</span>
                                            <span>{{address.country||''}}</span>
                                            <span v-if="address.country">.</span>
                                        </div>
                                        <div class="d-flex align-items-center pl-3">
                                            <div class="pointer" @click="addAddress(index,'edit')">
                                                <i class="icon icon-pencil new-blue-text fs-14"></i>
                                            </div>
                                            <div class="ml-2 pointer" @click="deleteAddress(index)">
                                                <i class="icon icon-trash new-blue-text fs-14"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="hideAddAddressButton == false" class="mt-3 text-right">
                            <button class="btn btn-des-small mt-2 btn-margin new-field-btn d-block ml-auto mb-3 btn-width" @click="addAddress(null,'add')">+ Add Address</button>
                        </div>
                        <div v-else class="mt-3 text-right">
                            <button class="btn btn-des-small mt-2 btn-margin new-field-btn d-block ml-auto mb-3 btn-width" disabled style="position: relative;">+ Add Address
                                <hollow-dots-spinner style="position: absolute;margin: 0;top: 24px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                            </button>
                        </div>
                    </div>
                    <div class="header-outer mt-3" v-if="socialMedia">
                        <span class="fw-500">Social Media Links</span>
                        <span class="pointer" @click="showSocialMedia">
                            <i v-if="socialMediaTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                            <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                        </span>
                    </div>
                    <div class="inner-div pt-10" v-if="socialMediaTab">
                        <div class="d-flex flex-wrap form-check form-check-inline">
                            <div class="social-media" v-for="(social, index) in social_media" :key="index" @click="selectedMedia(social)">
                                <div class="d-flex align-items-center justify-content-center w-100"  v-if="social_media.length == 0">
                                    <span>Please Add Social Media</span>
                                </div>
                                <div v-else style="color: #00448b; font-size: 25px; position: absolute; margin-left: 4.4em; cursor: pointer">
                                    <span>
                                        <i class="icon icon-pencil new-blue-text fs-14" @click="addSocial('edit',social.icon_url, index)"></i>
                                        <i class="icon icon-trash new-blue-text fs-14" @click="deleteSocial(index)"></i>
                                    </span>
                                </div>
                                <div class="d-flex justify-content-center mt-10">
                                    <img :src="social.icon_url" style="width: 3em; height: 3em;">
                                </div>
                                <div class="mt-2 fs-14 fw-500" style="text-align: center; text-transform: capitalize">{{ social.account_type }}</div>
                            </div>
                        </div>
                        <div>
                            <div v-if="hideAddMediaButton == false" class="mt-3 text-right">
                                <button  class="btn btn-des-small mt-2 ml-6 new-field-btn d-block ml-auto mb-3 btn-width" style="margin-right:4px;" @click="addSocial('add')">+ Add Media</button>
                            </div>
                            <div v-else class="mt-3 text-right">
                                <button  class="btn btn-des-small mt-2 ml-6 new-field-btn d-block ml-auto mb-3 btn-width" style="margin-right:4px;position: relative;" disabled>+ Add Media
                                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 24px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div v-if="selected_account == 'business'">
                        <div class="header-outer mt-3" >
                            <span class="fw-5">Referral Information</span>
                            <span class="pointer" @click="showReferrals">
                                <i v-if="referralTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                                <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                            </span>
                        </div>
                        <div class="inner-div" v-if="referralTab">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12 mt-5" v-for="(referral,index) in referral_details" :key="index">
                                    <div class="remainder-list mr-5" >
                                        <div class="d-flex justify-content-between align-items-baseline">
                                            <div class="text-justify text-flow word-break-all fw-600 fs-14">{{referral.referred_by_name}}</div>
                                            <div class="d-flex align-items-center pl-3">
                                                 <div class="pointer"  @click="addReferrals(index,'edit')">
                                                    <i class="icon icon-pencil new-blue-text fs-14"></i>
                                                </div>
                                                <div class="ml-2 pointer" @click="deleteReferrals(index)">
                                                    <i class="icon icon-trash new-blue-text fs-14"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-justify text-flow word-break-all">{{referral.referral_location.building_number + ((referral.referral_location.building_number).length > 0 ?  ", " : '')+referral.referral_location.street + ((referral.referral_location.street).length > 0 ?  ", " : '') + referral.referral_location.city + ((referral.referral_location.city).length > 0 ?  ", " : '') + referral.referral_location.state + ((referral.referral_location.state).length > 0 ?  ", " : '') + referral.referral_location.zip_code + ((referral.referral_location.zip_code).length > 0 ?  ", " : '') + referral.referral_location.country}}</div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="mt-3 text-right" v-if="addRefferralHide && hideAddReferralButton == false" >
                                    <button  class="btn btn-des-small mt-2  new-field-btn d-block ml-auto btn-margin btn-width mb-3"  @click="addReferrals(null,'add')">+ Add Referral</button>
                                </div>
                                <div v-else-if="hideAddReferralButton == true" class="mt-3 text-right">
                                    <button  class="btn btn-des-small mt-2  new-field-btn d-block ml-auto btn-margin btn-width mb-3" disabled style="position: relative;">+ Add Referral
                                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 24px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="disableButtonAndDisplayLoader == false" class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-2">
                        <button class="btn mt-2 ml-6 new-cancel-button" @click="cancel()">Cancel</button>
                        <button class="btn mt-2 ml-6 new-save-button" v-if="disable_save == false" @click="saveNewContact()" :disabled="(fields_not_changed_bus || fields_not_changed_per) && social_media_data_changed == false">Save</button>
                    </div>
                    <div v-else class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-2">
                        <button class="btn mt-2 ml-6 new-cancel-button" disabled style="border: none !important;">Cancel</button>
                        <button class="btn mt-2 ml-6 new-save-button" style="position: relative;" disabled>Save
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <edit-picture modal_name="editPic" hide @uploaded="uploaded" @deletePic="deletePic"></edit-picture>
        <edit-avatar modal_name="editAvatar" @newAvatar="newAvatar"></edit-avatar>
        <add-social-media-link modal_name="socialMediaLink" v-if="add_social_media_link"  :socialMediaType="socialMediaType" :url="url" :uid="uid" :mode="mode" @hideSocialMedia="hideSocialMedia" @saveSocialMedia="saveSocialMedia"></add-social-media-link>
        <contact-unsaved-modal modal_name="contactUnsavedModal" @discardContact="discardContact"></contact-unsaved-modal>
        <success-message v-if="success_contact" message="Your Contact data has been successfully submitted." modal_name="success-message" @hideSuccess="hideSuccess"></success-message>
        <add-address v-if="add_address" modal_name="add_address" @hideAddress="hideAddress" @saveAddress="saveAddress" :mode="mode"></add-address>
        <add-referrals v-if="add_referral" modal_name="add_referral" @hideReferrals="hideReferrals" @saveReferrals="saveReferrals" :mode="mode"></add-referrals>
    </div>
</template>

<script>
const SuccessMessage = () => import("../SuccessMessage");
const EditPicture = () => import("../alertModals/EditPicture");
const EditAvatar = () => import("../alertModals/EditAvatar");
const ContactUnsavedModal = () => import("../alertModals/ContactUnsavedModal");
const AddReferrals = () => import("./ReferralView.vue");
const AddSocialMediaLink = () => import("./AddSocialMediaLink.vue");
const AddAddress = () => import ("./AddAddress.vue");
import { HollowDotsSpinner } from "epic-spinners";
import { HalfCircleSpinner } from "epic-spinners";
import callreport from '../mixins/callreport';
import contacts from '../mixins/contacts';
import convert from '../mixins/convert';
import customer from '../mixins/customer';
import { EventBus } from '../eventBus/nav-bar-event';
import { SweetModal } from 'sweet-modal-vue';
import { debounce } from 'lodash';
export default {
    data() {
        const value2date = (dateRange) => {
            const date = new Date(dateRange)
            return dateRange ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : null
        }
        const date2value = (date) => {
            return date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : null
        }
        return {
            social_media_data_changed: false,
            stringified_bus_response: "",
            stringified_per_response: "",
            valueType: {
                value2date,
                date2value
            },
            bindProps: {
                mode: "international",
                defaultCountry: "US"
            },
            disableButtonAndDisplayLoader: false,
            hideAddAddressButton: false,
            hideAddMediaButton: false,
            hideAddReferralButton: false,
            territory:'',
            territory_options:[],
            temp_territories: [],
            territory_loading:false,
            territory_count:0,
            territory_scrollable: false,
            territory_visible: false,
            industry_type: null,
            add_referral:false,
            industry_options:[],
            title_options:['Dr','Miss','Mr','Mrs','Ms','Prof'],
            ajaxCallInProgress: false,
            selected_account :"business",
            success_msg: '',
            otherReferral:false,
            warning_msg: '',
            success_contact: false,
            add_address:false,
            add_social_media_link: false,
            toShow: "profile",
            basicInformationTab: true,
            contactTab: true,
            addressInformationTab: true,
            socialMediaTab: true,
            socialMedia :true,
            referralTab: true,
            referral:false,
            classificationsTab:true,
            states: [],
            showReferral:false,
            users: [],
            companies: [],
            tags:[],
            industry: [],
            search_key: "",
            limit: 10,
            skip: 0,
            addressIndex: "",
            is_tag_loading: false,
            relation:'',
            title: "",
            address: [],
            contact_mobile_number: {
                phone_number: "",
                dial_code: "1",
                country_code: "US",
                phone_type: ""
            },
            business_mobile_number: {
                phone_number: "",
                dial_code: "1",
                country_code: "US",
                phone_type: ""
            },
            alias: "",
            avatar_pic: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Avatar 1.svg",
            pic_type: "profile_pic",
            company: "",
            classification: {
                classification: "",
                sales_person: {},
                status: ""
            },
            contact_user_id: "",
            primary_email: "",
            alternate_email: "",
            first_name: "",
            job_title: "",
            tags: "",
            last_name: "",
            middle_name: "",
            notes: "",
            phone: [
                {
                    country_code: "",
                    dial_code: "",
                    phone_number: "",
                    phone_type: "mobile_number"
                },
                {
                    country_code: "",
                    dial_code: "",
                    phone_number: "",
                    phone_type: "business_phone"
                }
            ],
            profile_pic: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/No Picture.svg",
            referral_details: [],
            social_media: [],
            title: "",
            company_name :'',
            stored_company_name_for_edit:'',
            socialMediaType: "",
            socialMediaIndex: "",
            mode: "",
            url: "",
            uid: "",
            addressType: "",
            addressTypeIndex: "",
            //contacts_settings: {},
            add_title: '',
            new_title: '',
            reset_title: false,
            add_tag: '',
            new_tag: '',
            reset_tag: false,
            // wizard
            profiles:true,
            social_media_tab:true,
            is_classification_selected: false,
            is_status_selected: false,
            Industry: '',
            selected_address_index: null,
            selected_referral_index: null,
            selected_social_index: null,
            industry_type_options: ["Accommodation and Food Services","Administrative and Support, Waste Management and Remediation Services","Agriculture, Forestry, Fishing and Hunting","Arts, Entertainment and Recreation","Construction","Developer","Educational Services","EPC","Finance and Insurance","F&B","Health Care and Social Assistance","Information and Cultural Industries","Management of Companies and Enterprises","Manufacturing","Mining, Quarrying, and Oil and Gast Extraction","Other Businesses","Other Services (except public administration)","Professional, Scientific and Technical Services","Public Administration","Real Estate and Rental and Leasing","Residential Installation","Retail Trade","Transportation and Warehousing","Supplier","Utilities","Wholesale Trade"],
            relation_options: ['Aunt','Colleague','Daughter','Father','Friend','Mother','Son','Uncle'],
            contact_details: null,
            default_country_phone: null,
            default_country_business_phone: null,
            ajaxajaxCallInProgress: false,
            selected_media: null,
            addRefferralHide:true,
            business_true:false,
            personal_true :false,
            is_territory_selected: false,
            company_loading:false,
            company_name_options:[],
            company_name_count: 0,
            company_scrollable:false,
            temp_company_name:[],
            company_visible:'',
            add_company_name: '',
            new_company_name: '',
            reset_company_name: false,
            disable_save: false,
            isAvatar: false,
        }
    },
    mixins: [callreport,contacts,convert,customer],
    components: {
        EditPicture,
        EditAvatar,
        AddSocialMediaLink,
        ContactUnsavedModal,
        HalfCircleSpinner,
        HollowDotsSpinner,
        SuccessMessage,
        SweetModal,
        AddReferrals,
        AddAddress,
        EventBus
    },
    methods: {
        async checkEmailExist(data){
            if(this.selected_account == 'business'){
                try{
                    let entered_email = data.target.value
                    let id = this.$route.params.id == 'new' ? '' : this.$route.params.id
                    let params = {
                        primary_email: entered_email,
                        contact_id: id,
                        contact_edit: id == '' ? false : true
                    }
                    let response = await this.getEmailCheckAPI(params)
                } catch(error){
                    this.warning_msg = error
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            }
        },
        limitCompanyName(count){
            return `+ ${count} more`
        },
        //removing the company name
        removeCompanyName(option){
            this.temp_company_name.forEach((el,index)=>{
                if(el._id == option._id){
                    this.temp_company_name.splice(index,1)
                }
            })
        },
        //showing the company name which enterd manually
        /**@params = newTag*/
        addTag(newTag){
            const tag = {
                customer_name: newTag
            };
            this.company_name_options.push(tag);
            this.company_name = tag;

        },
        //Api call to search the company name
        /**@params = value*/
        async searchCompanyNameDebouncer(value){
            this.company_loading = true
            this.company_name_options = [];
            /**@params = search_key, @params = status , @params = limit , @params = skip, @params = sort_key, @params = sort_value*/
            let response = await this.getCustomerList({
                search_key: value || '',
                status: this.status,
                skip: 0,
                limit: 10,
                sort_key: "customer_name",
                sort_value: 1,
            })
            let company_name_opt = response.response
            //checking for the customer name
            company_name_opt.forEach(el => {
                if(el.hasOwnProperty('customer_name')){
                    el['full_name'] = el.customer_name
                }
                this.company_name_options.push(el);

            });
            this.company_name_options = this.company_name_options.filter((thing, index) => {
                const payload = JSON.stringify(thing);
                return index === this.company_name_options.findIndex(obj => {
                    return JSON.stringify(obj) === payload;
                });
            });

            this.company_name_count = response.response.length;
            this.company_loading = false
            this.company_scrollable = false
        },
        //Lazy loading of the companies
        /**@params = reached*/
        async reachedEndOfCompanies(reached){
            this.company_visible = reached
            if (reached) {
                if (this.company_scrollable == false) {
                    this.company_loading = true
                    /**@params = search_key, @params = status , @params = limit , @params = skip, @params = sort_key, @params = sort_value*/
                    let response = await this.getCustomerList({
                        status: this.status,
                        skip: this.company_name_count,
                        limit: 10,
                        search_key: "",
                        sort_key: "customer_name",
                        sort_value: 1,

                    })
                    this.temp_company_name = response.response.length;
                    if (response.skip == this.company_name_count) {
                        if (this.temp_company_name > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                if(el.hasOwnProperty('customer_name')){
                                    el['full_name'] = el.customer_name
                                }
                                this.company_name_options.push(el);
                            });
                            this.company_name_options = this.company_name_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.company_name_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });

                            });
                            // this.company_name_options = this.company_name_options.map(x => {return x.customer_name})
                            this.company_name_count += response.response.length;
                            //this.company_loading = false
                        } else {
                            this.company_scrollable = true
                            //this.company_loading = false
                        }
                    }
                    this.company_loading = false
                }
            }
        },
        //show the social media
        selectedMedia(social){
            this.selected_media = social
        },
        //Swtich account between business /personal contacts
        changeAccount(selected_account) {
            var data = this.selected_account;
            if (data == 'business') {
                this.Business = true;
                this.referral = true;
            } else if(data == 'personal') {
                this.Personal = true
                this.referral = false
            }
        },
        //get the contact info
        /**@params = number, @params = isValid , @params = country*/
        contactPhoneInput({number,isValid,country}) {
            this.phone[0].number = number;
            this.phone[0].isValid = isValid;
            this.phone[0].country = country;
            this.contact_mobile_number.dial_code = this.phone[0].country.dialCode
            this.contact_mobile_number.country_code = this.phone[0].country.iso2
        },
        //get the business contact info
        /**@params = number, @params = isValid , @params = country*/
        businessPhoneInput({number,isValid,country}) {
            this.phone[1].number = number;
            this.phone[1].isValid = isValid;
            this.phone[1].country = country;
            this.business_mobile_number.dial_code = this.phone[1].country.dialCode
            this.business_mobile_number.country_code = this.phone[1].country.iso2
        },
        hideSuccess() {
            this.success_contact = false;
            setTimeout(() => {
                this.$router.push("/listcontacts")
            }, 1000);
        },
        //add title manually
        addTitle(){
            if(this.add_title){
                this.reset_title = true
                if(this.reset_title){
                    this.new_title =this.add_title
                }
            }
        },
        //search the title
        searchTitleDebouncer(search_key) {
            this.add_title = search_key;
        },
        //search the industry
        searchIndustry(search_key) {
            this.add_industry = search_key;
        },
        //redirecting to the settings of the territory
        changeTerritoryView(){
            let territory = true
            let routeData = this.$router.resolve({name: 'Settings', query: {territory:territory}});
            window.open(routeData.href, '_blank');
        },
        //Api call to search Territory
        /**@params = search*/
        async searchTerritoryDebouncer(search) {
            this.territory_loading = true
            /**@params = skip, @params = limit , @params = search_key*/
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: search
            }
            let response = await this.getTerritoryList(params)
            this.territory_options = response.response
            this.territory_options = this.territory_options.filter((thing, index) => {
                const payload = JSON.stringify(thing);
                return index === this.territory_options.findIndex(obj => {
                    return JSON.stringify(obj) === payload;
                });
            });
            this.territory_count = this.territory_options.length
            this.territory_loading  = false
            this.territory_scrollable = false
        },
        //Api call to fetch the territory
        async fetchTerritory(){
            this.territory_loading = true
            /**@params = skip, @params = limit , @params = search_key*/
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: ""
            }
            let response = await this.getTerritoryList(params)
            this.territory_options = response.response
            this.territory_options = this.territory_options.filter((thing, index) => {
                const payload = JSON.stringify(thing);
                return index === this.territory_options.findIndex(obj => {
                    return JSON.stringify(obj) === payload;
                });
            });
            this.territory_count = this.territory_options.length
            this.territory_loading  = false
            this.territory_scrollable = false
        },
        //lazy loading to fetch territory
        async reachedEndOfTerritories(reached) {
            this.territory_visible = reached
            if (reached) {
                if (this.territory_scrollable == false) {
                    this.territory_loading = true
                    /**@params = skip, @params = limit , @params = search_key*/
                    let response = await this.getTerritoryList({
                        skip: this.territory_count,
                        limit: 10,
                        search_key: ""
                    })
                    this.temp_territories = response.response.length;
                    if (response.skip == this.territory_count) {
                        if (this.temp_territories > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.territory_options.push(el);
                            });
                            this.territory_options = this.territory_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.territory_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.territory_count += response.response.length;
                            this.territory_loading = false
                        } else {
                            this.territory_scrollable = true
                            this.territory_loading = false
                        }
                    }
                    this.territory_loading = false
                }
            }
        },
        limitTerritory(count){
            return `+ ${count} more`
        },
        //remove the territory data
        removeTerritory(option){
            this.temp_territories.forEach((el,index)=>{
                if(el._id == option._id){
                    this.temp_territories.splice(index,1)
                }
            })
        },
        //Api call to get the list of industries
        async getIndustries() {
            this.load_settings = true;
            let res = await this.$http.get("/company/get_industry_type");
            if (res.data.status_id == 1) {
                this.industry_type_options = res.data.response.value;
            }
        },
        //setting the reset title as true/false
        titleInput(){
            if(this.new_title == ""){
                this.reset_title = false
            }
        },
        //change the settings of the contacts
        changeView(){
            let contacts = true
            let routeData = this.$router.resolve({name: 'Settings', query: {contacts:contacts}});
            window.open(routeData.href, '_blank');
        },
        //showing/hiding the basic information tab value
        showBasicInformation() {
            if (this.basicInformationTab) {
                this.basicInformationTab = false;
            } else {
                this.basicInformationTab = true;
            }
        },
        //showing/hiding the contact tab value
        showContact() {
            if (this.contactTab) {
                this.contactTab = false;
            } else {
                this.contactTab = true;
            }
        },
        //showing/hiding the social media value
        showSocialMedia() {
            if (this.socialMediaTab) {
                this.socialMediaTab = false;
            } else {
                this.socialMediaTab = true;
            }
        },
         //showing/hiding the social media value
        showReferrals() {
            if (this.referralTab) {
                this.referralTab = false;
            } else {
                this.referralTab = true;
            }
        },
        //showing/hiding the claasifications value
        showClassifications() {
            if (this.classificationsTab) {
                this.classificationsTab = false;
            } else {
                this.classificationsTab = true;
            }
        },
        //edit picture of the contact
        editPicture() {
            // if (this.pic_type == "avatar") {
            //     this.pic_type = "profile_pic";
            // }
            
            if (this.pic_type == "profile_pic") {
                EventBus.$emit("profile_picture", this.profile_pic)
            this.$modal.show("editPic");
            }
        },
        //edit avatar of the contact
        editAvatar() {
            // if (this.pic_type == "profile_pic") {
            //     this.pic_type = "avatar";
            // }
            if (this.pic_type == "avatar") {
            this.$modal.show("editAvatar");
            }
        },
        //getting the url of uploaded pic
        uploaded(url) {
            this.profile_pic = url;
        },
        //getting the url of avatar
        newAvatar(url) {
            this.avatar_pic = url;
        },
        //setting the pic after deleting the picture
        deletePic() {
            this.profile_pic = "/static/images/No Picture.svg";
        },
        //adding social media data
        /**@params = mode , @params = type, @params = index*/
        addSocial(mode, type ,index) {
            if(mode == 'add'){
                this.hideAddMediaButton = true;
            }
            this.selected_social_index = index
            this.add_social_media_link = true
            localStorage.setItem("selected_social",null)
            this.mode = mode;
            this.type = type;
            this.socialMediaType = type;
            if(this.selected_social_index != null){
                localStorage.setItem("selected_social",JSON.stringify(this.social_media[index]))
            }
            setTimeout(() => {
                this.hideAddMediaButton = false;
                this.$modal.show("socialMediaLink");
            }, 500);
        },
        //delete the social media dating
        deleteSocial(index){
            this.social_media_data_changed = true;
            this.social_media.splice(index,1)
        },
        //Api call to create/edit social media
        /**@params = params*/
        saveSocialMedia(params) {
            this.social_media_data_changed = true;
            let value = params.params;
            let mode = params.mode;
            if(this.selected_social_index != null && mode == 'add'){
                this.social_media[this.selected_social_index].account_url = value.url_data
                this.address[this.selected_social_index].account_id = value.uid_data
                this.social_media[this.selected_social_index].account_type =value.value
                this.social_media[this.selected_social_index].icon_url = value.icon_url
            }else if(this.selected_social_index == null && mode == 'add'){
                this.social_media.push({
                    account_url: value.url_data,
                    account_id: value.uid_data,
                    account_type: value.value,
                    icon_url : value.icon_url
                })
            }
            if(this.selected_social_index != null && mode == 'edit'){
                this.social_media[this.selected_social_index].account_url = value.url_data
                this.social_media[this.selected_social_index].account_id = value.uid_data
                this.social_media[this.selected_social_index].icon_url = value.icon_url
            }else if(this.selected_social_index == null && mode == 'edit'){
                this.social_media.push({
                    account_url: value.url_data,
                    account_id: value.uid_data ,
                    icon_url : value.icon_url
                })
            }
        },
        //hide the social media data
        hideSocialMedia() {
            this.add_social_media_link = false
        },
        changeAddressType(type,index) {
            /**@params = type , @params = index*/
            this.$modal.show("changeAddressType");
            this.addressType = type;
            this.addressTypeIndex = index;
        },
        //Adding the address of the contact data
        /**@params = type , @params = index*/
        addAddress(index, mode) {
            if(mode === 'add'){
                this.hideAddAddressButton = true;
            }
            this.selected_address_index = index
            this.add_address = true
            this.mode = mode
            localStorage.setItem("selected_address",null)
            if(this.selected_address_index != null){
                localStorage.setItem("selected_address",JSON.stringify(this.address[index]))
            }
            setTimeout(() => {
                this.hideAddAddressButton = false;
                this.$modal.show("add_address");
            }, 500);
        },
        //hiding the address
        hideAddress() {
            this.add_address = false
        },
        //calling this method to getting the save address from address modal
        saveAddress(value) {
            //getting address form the address popup
            if(this.selected_address_index != null){
                this.address[this.selected_address_index].building_number = ""
                this.address[this.selected_address_index].address_type = "mailing_address"
                this.address[this.selected_address_index].city = value.city
                this.address[this.selected_address_index].country = value.country
                this.address[this.selected_address_index].state = value.state
                this.address[this.selected_address_index].street = value.street
                this.address[this.selected_address_index].zip_code = value.zip_code
                this.address[this.selected_address_index].township = value.township
            }
            else if(this.selected_address_index == null){
                this.address.push({
                    building_number: "",
                    address_type: "mailing_address",
                    city: value.city,
                    country: value.country,
                    state: value.state,
                    street: value.street,
                    zip_code: value.zip_code,
                    township: value.township,
                    latitude: value.latitude || '0',
                    longitude: value.longitude || '0',
                })

            }
        },
        //Calling referral modal to add referral data
        /**@params = mode */
        addReferrals(index, mode) {
            if(mode == 'add'){
                this.hideAddReferralButton = true;
            }
            this.selected_referral_index = index
            this.add_referral = true
            this.mode = mode;
            localStorage.setItem("selected_referrals",null)

            if(this.selected_referral_index != null){
                localStorage.setItem("selected_referrals",JSON.stringify(this.referral_details[index]))
            }
            setTimeout(() => {
                this.hideAddReferralButton = false;
                this.$modal.show("add_referral");
            }, 500);

        },
        //splicing the referral details
        /**@params = index */
        deleteReferrals(index) {
            this.referral_details.splice(index,1)
            this.addRefferralHide = true
        },
        //hide the refferal modal
        hideReferrals() {
            this.add_referral = false
        },
        //getting the save refferal data form referral modal
        saveReferrals(value) {
            if(this.selected_referral_index != null){
                this.referral_details[this.selected_referral_index].contact_referral_type = value.contact_referral_type.value
                this.referral_details[this.selected_referral_index].icon_url = value.icon_url
                this.referral_details[this.selected_referral_index].referred_by_name = value.referred_by.full_name
                this.referral_details[this.selected_referral_index].referred_by = value.referred_by.id
                this.referral_details[this.selected_referral_index].referral_date = value.referral_date
                this.referral_details[this.selected_referral_index].referral_time = value.referral_time
                this.referral_details[this.selected_referral_index].referral_location = {
                    building_number: "",
                    street: value.address.street,
                    city: value.address.city,
                    state: value.address.state,
                    zip_code: value.address.zip_code,
                    country: value.address.country,
                    township: value.address.township,
                    address_type: "work",
                    latitude: value.address.latitude || '0',
                    longitude: value.address.longitude || '0',
                }
                this.addRefferralHide = false
            }
            else if(this.selected_referral_index == null){
                this.referral_details.push({
                    contact_referral_type: value.contact_referral_type.value,
                    icon_url: value.icon_url,
                    referred_by_name: value.referred_by.full_name,
                    referred_by: value.referred_by.id,
                    referral_date: value.referral_date,
                    referral_time: value.referral_time,
                    referral_location: {
                        building_number: "",
                        street: value.address.street,
                        city: value.address.city,
                        state: value.address.state,
                        zip_code: value.address.zip_code,
                        country: value.address.country,
                        township: value.address.township,
                        address_type: "work",
                        latitude: value.address.latitude || '0',
                        longitude: value.address.longitude || '0',
                    }
                })
                this.addRefferralHide = false
            }
        },
        //deleting the address
        /**@params = index */
        deleteAddress(index) {
            this.address.splice(index,1);
        },
        //discard the contact changes and redirecticng to the list of contacts
        discardContact() {
            this.$router.push("/listcontacts");
        },
        errorHandler(err) {
            if (err.code == 1) {
                // alert("Error: Access is denied!");
            } else if (err.code == 2) {
                // alert("Error: Position is unavailable!");
            }
        },
        firstNameSelected(option) {
            this.contact_user_id = option._id;
            this.middle_name = option.middle_name;
            this.last_name = option.last_name;
        },
        //get the settings list
       /* async getOrganisationSettings() {
            this.ajaxCallInProgress = true;
            let res = await this.$http.get("/organisation_settings/list");
            if (res.data.status_id == 1) {
               // this.contacts_settings = res.data.response.contacts_settings;
            }
            this.ajaxCallInProgress = false;
        },*/
        handleValidationError() {
            const firstField = Object.keys(this.errors.collect())[0];
            if(firstField.includes('multiselect')) {
                this.$refs[`${firstField}Input`].$el.focus();
            } else {
                this.$refs[`${firstField}Input`].focus();
            }
        },
        //Api call to save the created/updated contact details
        saveNewContact() {
            this.$validator.validateAll().then(async result => {
                let temp_data = false
                if(result == true) {
                    this.disableButtonAndDisplayLoader = true;
                    //if contact is created
                    if(this.$route.params.id == 'new'){
                        //checking the type of the contact either businees / personal
                        if(this.selected_account == 'business'){
                            if(this.create_business_contact.industry_type == null) {
                                temp_data = false;
                            } else {
                                temp_data = true;
                            }
                            if(temp_data == true) {
                                this.create_business_contact['contact_social_media'] = []
                                this.social_media.forEach(x => {
                                    this.create_business_contact.contact_social_media.push({
                                        media_type: x.account_type,
                                        media_user_id: x.account_id,
                                        media_url: x.account_url,
                                        icon_url : x.icon_url
                                    })
                                })
                                try{
                                    let response = await this.createBusinessContact(this.create_business_contact)
                                    this.disable_save = true;
                                    this.success_msg = response.message
                                    this.$refs.success_modal.open();
                                    setTimeout(() => {
                                        localStorage.setItem("TabContactsActive",'Business')
                                        localStorage.setItem("contact_type","business")
                                        this.$refs.success_modal.close();
                                        this.disable_save = false;
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$router.push({
                                            path: '/contacts/view_contact/' + response.contact_id
                                        })
                                    }, 3000);
                                } catch(error){
                                    this.warning_msg = error
                                    this.$refs.warning_modal.open();
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$refs.warning_modal.close();
                                    }, 3000);
                                }
                            } else {
                                this.warning_msg = "Madnatory Fields are required"
                                this.$refs.warning_modal.open();
                                this.disableButtonAndDisplayLoader = false;
                            }
                        }
                        //api call for personal contact
                        else{
                            if(this.create_personal_contact.relation == '') {
                                temp_data = false;
                            } else {
                                temp_data = true;
                            }
                            if(temp_data == true) {
                                this.create_personal_contact['contact_social_media'] = []
                                this.social_media.forEach(x => {
                                    this.create_personal_contact.contact_social_media.push({
                                        media_type: x.account_type,
                                        media_user_id: x.account_id,
                                        media_url: x.account_url,
                                        icon_url : x.icon_url
                                    })
                                })
                                try{
                                    let response = await this.createPersonalContact(this.create_personal_contact)
                                    this.disable_save = true;
                                    this.success_msg = response.message
                                    this.$refs.success_modal.open();
                                    setTimeout(() => {
                                        localStorage.setItem("contact_type","personal")
                                        localStorage.setItem("TabContactsActive",'Personal')
                                        this.$refs.success_modal.close();
                                        this.disable_save = false;
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$router.push({
                                            path: '/contacts/view_contact/' + response.contact_id
                                        })
                                    }, 3000);
                                } catch(error){
                                    this.warning_msg = error
                                    this.$refs.warning_modal.open();
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$refs.warning_modal.close();
                                    }, 3000);
                                }
                            } else {
                                this.warning_msg = "Madnatory Fields are required"
                                this.$refs.warning_modal.open();
                                this.disableButtonAndDisplayLoader = false;
                            }
                        }
                    }
                    //if contact is updated
                    else{
                        if(this.selected_account == 'business'){
                            this.create_business_contact['id'] = this.$route.params.id
                            this.create_business_contact['contact_social_media'] = []
                            this.social_media.forEach(x => {
                                this.create_business_contact.contact_social_media.push({
                                    media_type: x.account_type,
                                    media_user_id: x.account_id,
                                    media_url: x.account_url,
                                    icon_url : x.icon_url
                                })
                            })
                            try{
                                let response = await this.editBusinessContact(this.$route.params.id,this.create_business_contact)
                                this.disable_save = true;
                                this.success_msg = response.message
                                this.$refs.success_modal.open();
                                setTimeout(() => {
                                    this.$refs.success_modal.close();
                                    this.disableButtonAndDisplayLoader = false;
                                    this.disable_save = false;
                                    this.$router.push({
                                        path: '/contacts/view_contact/' + this.$route.params.id
                                    })
                                }, 3000);
                            } catch(error){
                                    this.warning_msg = error
                                    this.$refs.warning_modal.open();
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$refs.warning_modal.close();
                                    }, 3000);
                                }
                        }
                        else{
                            if(this.selected_account == 'personal'){
                                this.create_business_contact['id'] = this.$route.params.id
                                this.create_personal_contact['contact_social_media'] = []
                                this.social_media.forEach(x => {
                                    this.create_personal_contact.contact_social_media.push({
                                        media_type: x.account_type,
                                        media_user_id: x.account_id,
                                        media_url: x.account_url,
                                        icon_url : x.icon_url
                                    })
                                })
                                try{
                                    let response = await this.editPersonalContact(this.$route.params.id,this.create_personal_contact)
                                    this.disable_save = true;
                                    this.success_msg = response.message
                                    this.$refs.success_modal.open();
                                    setTimeout(() => {
                                        this.$refs.success_modal.close();
                                        this.disable_save = false;
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$router.push({
                                            path: '/contacts/view_contact/' + this.$route.params.id
                                        })
                                    }, 3000);
                                } catch(error){
                                    this.warning_msg = error
                                    this.$refs.warning_modal.open();
                                    setTimeout(() => {
                                        this.disableButtonAndDisplayLoader = false;
                                        this.$refs.warning_modal.close();
                                    }, 3000);
                                }
                            }
                        }
                    }
                } else{
                    return this.handleValidationError();
                }
            });
        },
        cancel() {
            this.$router.go(-1)
        },
        //load contact details getting from get api
        async loadContactDetails(){
            this.ajaxCallInProgress = true;
            let type = localStorage.getItem("contact_type")
            //checking the type of the contact business/personal
            if(type == 'business'){
                this.selected_account = "business"
                this.ajaxajaxCallInProgress = true
                let response = await this.getBusinessContactDetails(this.$route.params.id)
                this.contact_details = response.response
                this.pic_type = this.contact_details.profile_image_type
                if(this.pic_type == 'profile_pic'){
                    this.profile_pic = this.contact_details.profile_image
                }
                else{
                    this.avatar_pic = this.contact_details.profile_image
                }
                this.title = this.contact_details.title
                if(this.contact_details.territory_id != ""){
                    this.territory = {name: this.contact_details.territory, id: this.contact_details.territory_id}
                }
                this.first_name = this.contact_details.first_name
                this.middle_name = this.contact_details.middle_name
                this.last_name = this.contact_details.last_name
                this.job_title = this.contact_details.job_title
                this.industry_type = this.contact_details.industry_type
                this.notes = this.contact_details.notes
                this.primary_email = this.contact_details.primary_email
                this.alternate_email = this.contact_details.alternate_email
                this.contact_details.contact_address.forEach(x => {
                    this.address.push({
                        building_number: x.building_number,
                        address_type: "mailing_address",
                        city: x.city,
                        country: x.country,
                        state: x.state,
                        street: x.street,
                        zip_code: x.zip_code,
                        township: x.township,
                        latitude: x.latitude || '0',
                        longitude: x.longitude || '0',
                    })
                })
                this.contact_details.contact_social_media.forEach(x => {
                    this.social_media.push({
                        //logo: x.media_type == 'Facebook' ? 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Facebook.svg' : x.media_type == 'Twitter' ?  'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/Twitter.svg' : x.media_type == 'LinkedIn' ?  '/static/icons/newicon/linkedin.png' :  x.media_type == 'Instagram' ? '/static/icons/newicon/insta.png' :'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/others-contact-icon.png',
                        account_url: x.media_url,
                        account_id: x.media_user_id,
                        account_type: x.media_type  ,
                        icon_url : x.icon_url
                    })
                })
                if(this.contact_details.hasOwnProperty('contact_referral')){
                    this.referral_details.push({
                        contact_referral_type: this.contact_details.contact_referral.contact_referral_type,
                        icon_url: this.contact_details.contact_referral.icon_url,
                        referred_by_name: this.contact_details.contact_referral.referred_by_name,
                        referred_by: this.contact_details.contact_referralreferred_by,
                        referral_date: this.contact_details.contact_referral.referral_date,
                        referral_time: this.contact_details.contact_referral.referral_time,
                        referral_location: {
                            building_number: this.contact_details.contact_referral.referral_location.building_number,
                            street: this.contact_details.contact_referral.referral_location.street,
                            city: this.contact_details.contact_referral.referral_location.city,
                            state: this.contact_details.contact_referral.referral_location.state,
                            zip_code: this.contact_details.contact_referral.referral_location.zip_code,
                            country: this.contact_details.contact_referral.referral_location.country,
                            township: this.contact_details.contact_referral.referral_location.township,
                            address_type: this.contact_details.contact_referral.referral_location.address_type,
                            latitude: this.contact_details.contact_referral.referral_location.latitude || '0',
                            longitude:  this.contact_details.contact_referral.referral_location.longitude || '0',
                        }
                    })
                    if (this.referral_details.length == 1) {
                        this.addRefferralHide = false
                    } else{
                        this.addRefferralHide = true
                    }
                }
                if(this.contact_details.contact_phone_number.length > 1){
                    this.phone = [
                        {
                            number: this.contact_details.contact_phone_number[0].phone_number,
                            isValid: false,
                            country: {
                                dialCode: this.contact_details.contact_phone_number[0].dial_code,
                                iso2: this.contact_details.contact_phone_number[0].country_code
                            }
                        },
                        {
                            number: this.contact_details.contact_phone_number[1].phone_number,
                            isValid: false,
                            country: {
                                dialCode: this.contact_details.contact_phone_number[1].dial_code,
                                iso2: this.contact_details.contact_phone_number[1].country_code
                            }
                        },
                    ]
                }
                else{
                    this.phone = [
                        {
                            number: this.contact_details.contact_phone_number[0].phone_number,
                            isValid: false,
                            country: {
                                dialCode: this.contact_details.contact_phone_number[0].dial_code,
                                iso2: this.contact_details.contact_phone_number[0].country_code
                            }
                        }
                    ]
                }
                this.contact_mobile_number = {
                    phone_number: this.contact_details.contact_phone_number[0].phone_number,
                    dial_code: this.phone[0].country.dialCode,
                    country_code: this.phone[0].country.iso2,
                    phone_type: this.contact_details.contact_phone_number[0].phone_type
                }
                if(this.contact_details.contact_phone_number.length > 1){
                    this.business_mobile_number = {
                        phone_number: this.contact_details.contact_phone_number[1].phone_number,
                        dial_code: this.phone[1].country.dialCode,
                        country_code: this.phone[1].country.iso2,
                        phone_type: this.contact_details.contact_phone_number[1].phone_type
                    }
                }
                this.default_country_phone = this.phone[0].country.country_code
                if(this.contact_details.contact_phone_number.length > 1){
                    this.default_country_business_phone = this.phone[1].country.country_code
                }
                this.stored_company_name_for_edit = JSON.parse(JSON.stringify(this.contact_details.company_name))
                this.company_name = this.contact_details.company_name
                this.ajaxajaxCallInProgress = false
                this.stringified_bus_response = JSON.stringify(this.create_business_contact)
            }
            //fetching the data for personal contacts
            else{
                this.selected_account = "personal"
                this.ajaxajaxCallInProgress = true
                let response = await this.getPersonalContactDetails(this.$route.params.id)
                this.contact_details = response.response
                this.pic_type = this.contact_details.profile_image_type
                this.isAvatar = this.contact_details.profile_image_type == 'avatar' ? true : false
                if(this.pic_type == 'profile_pic'){
                    this.profile_pic = this.contact_details.profile_image
                }
                else{
                    this.avatar_pic = this.contact_details.profile_image
                }
                this.title = this.contact_details.title
                this.first_name = this.contact_details.first_name
                this.middle_name = this.contact_details.middle_name
                this.last_name = this.contact_details.last_name
                this.relation = this.contact_details.relation
                this.notes = this.contact_details.notes
                this.primary_email = this.contact_details.primary_email
                this.alternate_email = this.contact_details.alternate_email
                this.contact_details.contact_address.forEach(x => {
                    this.address.push({
                        building_number: x.building_number,
                        address_type: "mailing_address",
                        city: x.city,
                        country: x.country,
                        state: x.state,
                        street: x.street,
                        zip_code: x.zip_code,
                        township: x.township,
                        latitude: x.latitude || '0',
                        longitude: x.longitude || '0',
                    })
                })
                //fetching data for social media
                this.contact_details.contact_social_media.forEach(x => {
                    this.social_media.push({
                        account_url: x.media_url,
                        account_id: x.media_user_id,
                        account_type: x.media_type,
                        icon_url : x.icon_url
                    })
                })
                if(this.contact_details.contact_phone_number.length > 1){
                    this.phone = [
                        {
                            number: this.contact_details.contact_phone_number[0].phone_number,
                            isValid: false,
                            country: {
                                dialCode: this.contact_details.contact_phone_number[0].dial_code,
                                iso2: this.contact_details.contact_phone_number[0].country_code
                            }
                        },
                        {
                            number: this.contact_details.contact_phone_number[1].phone_number,
                            isValid: false,
                            country: {
                                dialCode: this.contact_details.contact_phone_number[1].dial_code,
                                iso2: this.contact_details.contact_phone_number[1].country_code
                            }
                        },
                    ]
                }
                else{
                    this.phone = [
                        {
                            number: this.contact_details.contact_phone_number[0].phone_number,
                            isValid: false,
                            country: {
                                dialCode: this.contact_details.contact_phone_number[0].dial_code,
                                iso2: this.contact_details.contact_phone_number[0].country_code
                            }
                        }
                    ]
                }
                this.contact_mobile_number = {
                    phone_number: this.contact_details.contact_phone_number[0].phone_number,
                    dial_code: this.phone[0].country.dialCode,
                    country_code: this.phone[0].country.iso2,
                    phone_type: this.contact_details.contact_phone_number[0].phone_type
                }
                if(this.contact_details.contact_phone_number.length > 1){
                    this.business_mobile_number = {
                        phone_number: this.contact_details.contact_phone_number[1].phone_number,
                        dial_code: this.phone[1].country.dialCode,
                        country_code: this.phone[1].country.iso2,
                        phone_type: this.contact_details.contact_phone_number[1].phone_type
                    }
                }
                this.default_country_phone = this.phone[0].country.country_code
                if(this.contact_details.contact_phone_number.length > 1){
                    this.default_country_business_phone = this.phone[1].country.country_code
                }
                this.ajaxajaxCallInProgress = false;
                this.stringified_per_response = JSON.stringify(this.create_personal_contact)
            }
            this.ajaxCallInProgress = false;
        },
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        //this use as parmas to create business contacts
        create_business_contact(){
            return {
                profile_image: this.pic_type == 'avatar' ? this.avatar_pic : this.profile_pic,
                profile_image_type: this.pic_type,
                title: this.title,
                first_name: this.first_name,
                middle_name: this.middle_name,
                last_name: this.last_name,
                primary_email: this.primary_email.toLowerCase(),
                alternate_email: this.alternate_email,
                industry_type: this.industry_type,
                job_title: this.job_title,
                company_name: this.company_name.customer_name,
                notes: this.notes,
                contact_referral: this.referral_details[0],
                contact_phone_number: [
                    {
                        phone_type: "work",
                        phone_number: this.contact_mobile_number.phone_number,
                        country_code: this.contact_mobile_number.country_code,
                        dial_code: this.contact_mobile_number.dial_code
                    },
                    {
                        phone_type: "business",
                        phone_number: this.business_mobile_number.phone_number,
                        country_code: this.business_mobile_number.country_code,
                        dial_code: this.business_mobile_number.dial_code
                    }
                ],
                contact_address: this.address,
                territory_id: this.territory.id,
            }
        },
        //this use as parmas to create personal contacts
        create_personal_contact(){
            return {
                profile_image: this.pic_type == 'avatar' ? this.avatar_pic : this.profile_pic,
                profile_image_type: this.pic_type,
                title: this.title,
                first_name: this.first_name,
                middle_name: this.middle_name,
                last_name: this.last_name,
                primary_email: this.primary_email,
                alternate_email: this.alternate_email,
                notes: this.notes,
                relation: this.relation,
                contact_phone_number: [
                    {
                        phone_type: "work",
                        phone_number: this.contact_mobile_number.phone_number,
                        country_code: this.contact_mobile_number.country_code,
                        dial_code: this.contact_mobile_number.dial_code
                    },
                    {
                        phone_type: "business",
                        phone_number: this.business_mobile_number.phone_number,
                        country_code: this.business_mobile_number.country_code,
                        dial_code: this.business_mobile_number.dial_code
                    }
                ],
                contact_address: this.address,
            }
        },
        fields_not_changed_bus(){
            return this.stringified_bus_response == JSON.stringify(this.create_business_contact)
        },
        fields_not_changed_per(){
            return this.stringified_per_response == JSON.stringify(this.create_personal_contact)
        }
    },
    mounted() {
        //checking the route to call the load contact api
        if(this.$route.params.id != 'new'){
            this.ajaxajaxCallInProgress = true
            this.ajaxCallInProgress = true;
            setTimeout(() => {
                this.loadContactDetails()
            }, 1000);
        } 
        //setting the contact type based ont he user permission
        setTimeout(() => {
            if(!this.userPermissions.contacts_business.permitted_actions.create){
                this.business_true = true
                this.personal_true = false
                this.selected_account = "personal"
                this.$forceUpdate()
            }
            else if(!this.userPermissions.contacts_personal.permitted_actions.create){
                this.personal_true = true
                this.buiness_true = false
                this.selected_account = "business"
                this.$forceUpdate()
            }else {
                this.business_true = false
                this.personal_true = false
                this.selected_account = "business"
                this.$forceUpdate()
            }
        }, 500);
    },
    // watch : {
    //     "$route.path": function (path) {
    //         this.$router.go(0);  
    //     },
    // },
    created() {
        const dict = {
            custom: {
                mobile_number: {
                    required: () => "Phone Number is required",
                    min: () => "Phone Number must contain more than 9 numbers",
                },
                business_phone: {
                    //required: () => "Phone Number is required",
                    min: () => "Phone Number must contain more than 9 numbers",
                }

            }
        };
        this.$validator.localize("en", dict);
        //added debounce method for all search API's
        this.searchTitle = debounce(this.searchTitleDebouncer, 500)
        this.searchCompanyName = debounce(this.searchCompanyNameDebouncer, 500)
        this.searchTerritory = debounce(this.searchTerritoryDebouncer, 500)
    },
}
</script>

<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .header-outer {
        width: 100%;
        background: #00448b;
        color: #fff;
        font-size: 14px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 20px;
        padding-left: 26px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .inner-div {
        padding: 20px 50px;
    }
    .primary-tag {
        border-radius: 10px;
        font-size: 10px;
        font-weight: 500;
        padding: 2px 10px;
        color: #fff;
        height: max-content;
    }
    .social-media {
        background: #def0f9;
        border-radius: 5px;
        width: 10em;
        height: 10em;
        margin-right: 25px;
        margin-bottom: 30px;
    }
    .add-vendor{
        color: rgba(103, 103, 103, 0.84);
        position: inherit;
        background: #ffffff;
        width: 100%;
        height: 34px;
        line-height: 32px;
        padding-left: 18px;
        z-index: 9999;
        cursor: pointer;
        top: 84%;
        border: solid 1px #cdd2da;
    }
    .new-field-btn{
        color: #fff;
        background-color: #00448b;
    }
    .remainder-list{
        box-shadow: 0 0 3px 0 #939393;
        border: solid 1px #939393;
        border-radius: 6px;
        padding: 7px;
        height:100px;
        max-height: 100px !important;
        overflow: auto !important;
    }
    .btn-cancel-new{
        color: #d51650 !important;
        background-color: #fff;
    }
    .pointer-event {
        background-color: #fff !important;
    }
    .input-height {
        height: 40px!important;
    }
    .btn-width{
        width:160px!important;
    }
    .btn-margin {
        margin-right: 4px;
    }
    .radio-margin{
        margin-left: 35px;
    }
    .avatar-radio-margin {
        margin-left : 50px;
    }
    .text-line {
        text-decoration :none !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Contacts/EditContact.vue